<template>
  <div class="activity-log-trigger">
    <template>
      <v-icon
        color="orange darken-1"
        class="white--text activity-log-trigger__icon"
        flat
        role="button"
        tabindex="0"
        @click.stop="check()"
        @keydown.enter.stop.prevent="check()"
        @keydown.space.stop.prevent="check()"
        :disabled="loading"
        title="Activity Log"
        >visibility</v-icon
      >
    </template>
    <v-dialog
      v-model="dialog"
      max-width="36rem"
      content-class="activity-logs-dialog"
    >
      <v-form ref="form">
        <v-card class="activity-logs-card">
          <header class="activity-logs-header">
            <div class="activity-logs-header__brand">
              <div class="activity-logs-transport-badge" aria-hidden="true">
                <v-icon class="activity-logs-transport-badge__icon"
                  >directions</v-icon
                >
              </div>
              <div class="activity-logs-header__copy">
                <h2 class="activity-logs-title">{{ dialogTitle }}</h2>
              </div>
            </div>
            <v-btn
              icon
              class="activity-logs-close"
              @click.prevent="dialog = false"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <div class="activity-logs-body">
            <div v-if="activity.length" class="activity-logs-timeline">
              <article
                v-for="(data, i) in activity"
                :key="i"
                class="activity-log-entry"
                :class="{ 'activity-log-entry--latest': i === 0 }"
              >
                <div class="activity-log-entry__rail">
                  <div class="activity-log-entry__node">
                    <v-icon size="16">{{ logIcon(data.comments) }}</v-icon>
                  </div>
                </div>
                <div class="activity-log-entry__card">
                  <div class="activity-log-entry__top">
                    <div class="activity-log-entry__who">
                      <span class="activity-log-entry__avatar">{{
                        editorInitials(data)
                      }}</span>
                      <div class="activity-log-entry__meta">
                        <span class="activity-log-entry__label">Edited by</span>
                        <strong class="activity-log-entry__name">
                          {{ editorName(data) }}
                          <span class="activity-log-entry__emp"
                            >({{ editorTag(data) }})</span
                          >
                        </strong>
                      </div>
                    </div>
                    <time class="activity-log-entry__time">{{
                      getTime(data.editDate)
                    }}</time>
                  </div>
                  <p class="activity-log-entry__comment">
                    {{ data.comments }}
                  </p>
                </div>
              </article>
            </div>

            <div v-else class="activity-logs-empty">
              <div class="activity-logs-empty__icon" aria-hidden="true">
                <v-icon size="28">directions</v-icon>
              </div>
              <h3 class="activity-logs-empty__title">No activity yet</h3>
              <p class="activity-logs-empty__text">
                Updates for this shipment will appear here as the journey moves
                forward.
              </p>
            </div>
          </div>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      color="red darken-2"
      v-model="x.error"
      class="white--text"
      v-if="x.error"
      >{{ x.error }}</v-snackbar
    >
  </div>
</template>
<script>
import moment from "moment";
import ErrorBox from "@/components/Common/ErrorBox";
import { ApiService } from "@/services/api-service";
import { StorageKeys } from "../../constants/constants";
import { activityLogs, activityLogsCustomer } from "@/constants/api-urls.js";
export default {
  data() {
    return {
      x: {
        error: null,
      },
      operationName: "",
      activity: [],
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  props: {
    id: String,
    type: String,
    assignmentId: String,
    subType: Number,
    _id: String,
    permissions: String,
    section: String,
    whichId: String,
    sourceId: String,
  },
  created() {},
  components: {
    ErrorBox,
  },
  computed: {
    dialogTitle() {
      if (this.type === "milestone") {
        return "Milestone Activity Logs";
      }
      if (this.subType == 7) {
        return `Payment Logs · ${this.whichId || ""} ID ${this.id}`;
      }
      if (this.subType == 5) {
        return `Advance Logs · ${this.whichId || ""} ID ${this.id}`;
      }
      if (this.subType == 9) {
        return `SI Logs · ${this.id}`;
      }
      if (this.subType == 17) {
        return "Advance Logs";
      }
      if (this.subType == 15) {
        return `Receipt Logs · ${this.id}`;
      }
      if (this.subType == 10) {
        return `Loss To Trukkin · SI ${this.id}`;
      }
      if (this.subType == 16) {
        return `Additional Charges · ${this.id}`;
      }
      return `Activity Logs · ID ${this.id}`;
    },
  },
  methods: {
    // A log is written by an OMS/DMS user (editedBy), by the driver app
    // (editedByDriver), or by the system - a cron or script - with no editor.
    editorName(data) {
      if (data && data.editedBy) return data.editedBy.name;
      if (data && data.editedByDriver) return "DRIVER";
      return "SYSTEM";
    },
    editorTag(data) {
      if (data && data.editedBy) return data.editedBy.employeeID || "-";
      if (data && data.editedByDriver) return "App";
      return "Auto";
    },
    editorInitials(data) {
      if (!data || !data.editedBy) {
        return data && data.editedByDriver ? "DR" : "SY";
      }
      const name = data.editedBy.name;
      if (!name || typeof name !== "string") {
        return "TK";
      }
      const parts = name.trim().split(/\s+/).filter(Boolean);
      if (!parts.length) {
        return "TK";
      }
      if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
      }
      return (parts[0][0] + parts[1][0]).toUpperCase();
    },
    logIcon(comment) {
      const text = (comment || "").toLowerCase();
      if (
        text.includes("driver") ||
        text.includes("truck") ||
        text.includes("ship") ||
        text.includes("air") ||
        text.includes("sea") ||
        text.includes("transport")
      ) {
        return "directions";
      }
      if (text.includes("approv")) {
        return "check_circle";
      }
      if (text.includes("assign")) {
        return "person_pin_circle";
      }
      if (
        text.includes("price") ||
        text.includes("payment") ||
        text.includes("advance")
      ) {
        return "payment";
      }
      if (
        text.includes("sales") ||
        text.includes("order") ||
        text.includes("update") ||
        text.includes("generat")
      ) {
        return "edit";
      }
      if (text.includes("creat") || text.includes("new")) {
        return "add_circle";
      }
      return "history";
    },
    getIdforApi(type) {
      switch (type) {
        case "jobs":
          return this.$props._id;
        case "inquiry":
          return this.$props.id;
        case "requestTicket":
          return this.$props._id;
        case "driver":
          return this.$props.id;
        case "transporter":
          return this.$props._id;
        case "customer":
          return this.$props._id;
        case "shipmentType":
          return this.$props.id;
        case "assignment":
          return this.$props._id;
        case "advance":
          return this.$props._id;
        case "milestone":
          return this.$props._id;
        default:
          return this.$props.id;
      }
    },
    async check() {
      this.loading = true;
      if (this.$props.permissions) {
        this.operationName = this.$props.permissions;
        let y = await this.checkOpertaionPermission(this.operationName);
        if (y) {
          this.dialog = true;
          this.loading = false;
          this.getActivityLog();
        } else {
          this.loading = false;
          return;
        }
      } else {
        this.loading = false;
        this.dialog = true;
        this.getActivityLog();
      }
    },
    getTime(date) {
      return moment(date).format("ll hh:mm A");
    },

    getActivityLog() {
      if (this.processing) {
        return;
      } else {
        this.processing = true;
        if (this.$props.type == "1") {
          let body = {
            type: this.$props.type,
            entry_id: this.$props._id,
          };
          ApiService.postData(activityLogsCustomer, body).then(
            (response) => {
              this.dialog = true;
              this.activity = response.data.data;
              this.processing = false;
            },
            (error) => {
              this.x.error = "Failed to Fetch Activity Logs";
              this.processing = false;
            }
          );
        } else if (this.$props.type == "2") {
          let body = {
            type: "1",
            invoiceNumber: this.$props._id,
          };
          ApiService.postData(activityLogsCustomer, body).then(
            (response) => {
              this.dialog = true;
              this.activity = response.data.data;
              this.processing = false;
            },
            (error) => {
              this.x.error = "Failed to Fetch Activity Logs";
              this.processing = false;
            }
          );
        } else if (this.$props.type == "3") {
          let body = {
            type: "1",
            entry_id: this.$props._id,
          };
          ApiService.postData(activityLogsCustomer, body).then(
            (response) => {
              this.dialog = true;
              this.activity = response.data.data;
              this.processing = false;
            },
            (error) => {
              this.x.error = "Failed to Fetch Activity Logs";
              this.processing = false;
            }
          );
        } else if (this.$props.type == "4") {
          let body = {
            type: "1",
            lossTTId: this.$props._id,
          };
          ApiService.postData(activityLogsCustomer, body).then(
            (response) => {
              this.dialog = true;
              this.activity = response.data.data;
              this.processing = false;
            },
            (error) => {
              this.processing = false;
            }
          );
        } else if (this.$props.type == "12") {
          let body = {
            sourceId: this.$props.sourceId,
          };
          ApiService.postData(activityLogs, body).then(
            (response) => {
              this.dialog = true;
              this.activity = response.data.data;
              this.processing = false;
            },
            (error) => {
              this.x.error = "Failed to Fetch Activity Logs";
              this.processing = false;
            }
          );
        } else if (this.$props.type == "advance") {
          let body = {
            type: this.$props.type,
            id: this.$props.id,
          };
          ApiService.postData(activityLogs, body).then(
            (response) => {
              this.dialog = true;
              this.activity = response.data.data;
              this.processing = false;
            },
            (error) => {
              this.x.error = "Failed to Fetch Activity Logs";
              this.processing = false;
            }
          );
        } else {
          let body = {
            type: this.$props.type,
          };
          if (this.$props.subType) {
            body.subType = this.$props.subType;
          }
          if (this.$props.assignmentId) {
            body.assignmentId = this.$props.assignmentId;
          }
          body.id = this.getIdforApi(this.$props.type);
          ApiService.postData(activityLogs, body).then(
            (response) => {
              this.dialog = true;
              this.activity = response.data.data;
              this.processing = false;
            },
            (error) => {
              this.x.error = "Failed to Fetch Activity Logs";
              this.processing = false;
            }
          );
        }
      }
    },
  },
};
</script>
<style scoped>
.activity-log-trigger {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  padding: 0;
}

.activity-log-trigger__icon {
  align-items: center;
  display: inline-flex !important;
  justify-content: center;
  line-height: 1 !important;
  margin: 0 !important;
  text-align: center;
}

.activity-logs-card {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.activity-logs-header {
  align-items: flex-start;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.18), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 58%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.85rem;
  justify-content: space-between;
  padding: 1rem 1.15rem 0.9rem;
}

.activity-logs-header__brand {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  min-width: 0;
}

.activity-logs-transport-badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.8rem;
  box-shadow: 0 0.4rem 0.85rem rgba(28, 43, 95, 0.24);
  display: flex;
  flex: 0 0 auto;
  height: 2.75rem;
  justify-content: center;
  position: relative;
  width: 2.75rem;
}

.activity-logs-transport-badge::after {
  background: #f58220;
  border-radius: 999px;
  bottom: 0.3rem;
  content: "";
  height: 0.22rem;
  left: 0.55rem;
  position: absolute;
  right: 0.55rem;
}

.activity-logs-transport-badge__icon {
  color: #ffffff !important;
  font-size: 1.25rem !important;
  margin-top: -0.15rem;
}

.activity-logs-header__copy {
  min-width: 0;
}

.activity-logs-eyebrow {
  color: #c35f02;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin: 0 0 0.15rem;
  text-transform: uppercase;
}

.activity-logs-title {
  color: #1c2b5f;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin: 0;
  word-break: break-word;
}

.activity-logs-close {
  color: #5b6475 !important;
  margin: -0.25rem -0.35rem 0 0 !important;
}

.activity-logs-body {
  max-height: min(68vh, 32rem);
  overflow: auto;
  padding: 0.85rem 1rem 1.1rem;
  scrollbar-color: #f58220 transparent;
  scrollbar-width: thin;
}

.activity-logs-body::-webkit-scrollbar {
  width: 0.3125rem;
}

.activity-logs-body::-webkit-scrollbar-track {
  background: transparent;
}

.activity-logs-body::-webkit-scrollbar-thumb {
  background: #f58220;
  border-radius: 999px;
}

.activity-logs-timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
}

.activity-log-entry {
  display: grid;
  gap: 0.85rem;
  grid-template-columns: 1.75rem minmax(0, 1fr);
  padding: 0.35rem 0;
  position: relative;
}

.activity-log-entry:not(:last-child)::before {
  background: linear-gradient(180deg, #fdba74 0%, #e8e4db 100%);
  bottom: -0.35rem;
  content: "";
  left: 0.8rem;
  position: absolute;
  top: 2rem;
  width: 0.125rem;
}

.activity-log-entry__rail {
  display: flex;
  justify-content: center;
  padding-top: 0.85rem;
  position: relative;
  z-index: 1;
}

.activity-log-entry__node {
  align-items: center;
  background: #ffffff;
  border: 0.125rem solid #f58220;
  border-radius: 999px;
  box-shadow: 0 0 0 0.25rem #fff7ed;
  color: #ea7a1c;
  display: inline-flex;
  height: 1.75rem;
  justify-content: center;
  width: 1.75rem;
}

.activity-log-entry--latest .activity-log-entry__node {
  background: linear-gradient(160deg, #f58220 0%, #ea7a1c 100%);
  border-color: #ea7a1c;
  box-shadow: 0 0 0 0.25rem rgba(245, 130, 32, 0.16);
  color: #ffffff;
}

.activity-log-entry__card {
  background: #ffffff;
  border: 0.0625rem solid #ebe9e2;
  border-radius: 0.875rem;
  box-shadow: 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.04);
  padding: 0.9rem 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.activity-log-entry__card:hover {
  border-color: #fdba74;
  box-shadow: 0 0.5rem 1.25rem rgba(28, 43, 95, 0.08);
  transform: translateY(-0.0625rem);
}

.activity-log-entry--latest .activity-log-entry__card {
  background: linear-gradient(180deg, #fffaf4 0%, #ffffff 70%);
  border-color: #fdba74;
}

.activity-log-entry__top {
  align-items: flex-start;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  margin-bottom: 0.65rem;
}

.activity-log-entry__who {
  align-items: center;
  display: flex;
  gap: 0.65rem;
  min-width: 0;
}

.activity-log-entry__avatar {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2f4a8a 100%);
  border-radius: 0.7rem;
  color: #ffffff;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.6875rem;
  font-weight: 800;
  height: 2rem;
  justify-content: center;
  letter-spacing: 0.02em;
  width: 2rem;
}

.activity-log-entry__meta {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.activity-log-entry__label {
  color: #8a857c;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.activity-log-entry__name {
  color: #1a1916;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
  word-break: break-word;
}

.activity-log-entry__emp {
  color: #5b6475;
  font-weight: 600;
}

.activity-log-entry__time {
  background: #f6f5f2;
  border-radius: 999px;
  color: #5b6475;
  flex: 0 0 auto;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.3;
  padding: 0.3rem 0.55rem;
  white-space: nowrap;
}

.activity-log-entry__comment {
  color: #3a382f;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
  word-break: break-word;
}

.activity-logs-empty {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  justify-content: center;
  padding: 2.5rem 1rem 2rem;
  text-align: center;
}

.activity-logs-empty__icon {
  align-items: center;
  background: #fff7ed;
  border: 0.0625rem solid #fed7aa;
  border-radius: 1rem;
  color: #ea7a1c;
  display: flex;
  height: 3.5rem;
  justify-content: center;
  margin-bottom: 0.35rem;
  width: 3.5rem;
}

.activity-logs-empty__icon .v-icon {
  color: #ea7a1c !important;
}

.activity-logs-empty__title {
  color: #1c2b5f;
  font-size: 1rem;
  font-weight: 800;
  margin: 0;
}

.activity-logs-empty__text {
  color: #74716a;
  font-size: 0.8125rem;
  line-height: 1.5;
  margin: 0;
  max-width: 18rem;
}

html.oms-night-mode .application .activity-logs-card {
  background: var(--oms-surface) !important;
  border-color: var(--oms-border) !important;
  color: var(--oms-ink) !important;
}

html.oms-night-mode .application .activity-logs-header {
  background: linear-gradient(
    135deg,
    rgba(234, 122, 28, 0.16) 0%,
    var(--oms-surface) 55%,
    var(--oms-surface-soft) 100%
  );
  border-color: var(--oms-border);
}

html.oms-night-mode .application .activity-logs-title {
  color: #f8bd82;
}

html.oms-night-mode .application .activity-logs-eyebrow {
  color: #f0a45a;
}

html.oms-night-mode .application .activity-log-entry__card {
  background: var(--oms-surface-soft);
  border-color: var(--oms-border);
}

html.oms-night-mode .application .activity-log-entry--latest .activity-log-entry__card {
  background: rgba(234, 122, 28, 0.08);
  border-color: rgba(234, 122, 28, 0.35);
}

html.oms-night-mode .application .activity-log-entry__name {
  color: var(--oms-ink-strong);
}

html.oms-night-mode .application .activity-log-entry__comment,
html.oms-night-mode .application .activity-log-entry__emp {
  color: var(--oms-ink);
}

html.oms-night-mode .application .activity-log-entry__time {
  background: var(--oms-disabled-bg);
  color: var(--oms-muted);
}

html.oms-night-mode .application .activity-logs-empty__title {
  color: #f8bd82;
}

html.oms-night-mode .application .activity-logs-empty__text {
  color: var(--oms-muted);
}

html.oms-night-mode .application .activity-logs-empty__icon {
  background: rgba(234, 122, 28, 0.12);
  border-color: rgba(234, 122, 28, 0.35);
}

@media (max-width: 40rem) {
  .activity-logs-header {
    padding: 0.9rem 0.9rem 0.75rem;
  }

  .activity-logs-body {
    padding: 0.7rem 0.85rem 1rem;
  }

  .activity-log-entry__top {
    flex-direction: column;
  }

  .activity-log-entry__time {
    align-self: flex-start;
  }
}
</style>

<style>
.application .v-dialog.activity-logs-dialog,
#nav .v-dialog.activity-logs-dialog {
  border-radius: 1rem !important;
  overflow: visible !important;
}

.application .v-dialog.activity-logs-dialog .v-card.activity-logs-card,
#nav .v-dialog.activity-logs-dialog .v-card.activity-logs-card {
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
  max-height: min(88vh, 44rem);
  overflow: hidden;
}
</style>
